// extracted by mini-css-extract-plugin
export default {"main_section":"categories_main_section__5793G","card":"categories_card__VpkUH","btn":"categories_btn__0UVDs"};